export class TradeUtil {

    public static isOption(trade: Trade): trade is OptionTrade {
        return "expiry" in trade;
    }

    public static isEquity(trade: Trade): trade is EquityTrade {
        return "underlyingCode" in trade;
    }
}
